module.exports = __webpack_public_path__ + "img/not-authorized.1d8c0a31.svg";